<style type="text/stylesheet">
  /* Microsite USE ONLY -- This prevents the citi-header & citi-footer from showing for the microsites flow while the page loads */
.disable-citi-header ::ng-deep citi-header , .disable-citi-header ::ng-deep citi-footer {
    display: none;
}
</style>
<div id="cards_marketing_pages">
  @if(showHeader){
  <cbol-core [ngClass]="{ 'disable-citi-header': !showHeader }">
    <citi-simple-layout> </citi-simple-layout>
  </cbol-core>
  } @else {
    <router-outlet></router-outlet>
  }
</div>